<!-- 字典列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="dialogVisible" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <slideshowAction v-if="dialogVisible" ref="slideshowAction" @drawerCancel="drawerCancel"
                :actionData="actionData"></slideshowAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" label-width="100px">
                    <el-form-item>
                        <div style="display: flex;align-items: center;font-size: 13px;color:#606266;">
                            <label slot="label" :style="`margin-right:10px;${$common.labelStyle('分类名称')}`" style=""
                                v-html="'分类名称'"></label>
                            <el-cascader class="form_codition" :props="{ emitPath: false }"
                                v-model="getRequestData.classId" :options="classifyList" clearable></el-cascader>
                        </div>
                    </el-form-item>
                    <el-form-item label="是否首页轮播">
                        <label slot="label" :style="$common.labelStyle('是否首页轮播')" v-html="'是否首页轮播'"></label>
                        <el-radio-group v-model="getRequestData.state" @change="radioChange">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button :label="0">否</el-radio-button>
                            <el-radio-button :label="1">是</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="名称">
                        <label slot="label" :style="$common.labelStyle('名称')" v-html="'名称'"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.imgTitle" size="mini"
                            :clearable="true" placeholder="名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" @selection-change="selecDataAction"
                :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column align="center" prop="state" label="是否首页轮播" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state == 1" type="success" size="mini">是</el-tag>
                        <el-tag v-else type="danger" size="mini">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="className" label="分类名称" width="180">
                </el-table-column>
                <el-table-column align="center" prop="imgTitle" label="轮播图名称" min-width="150">
                </el-table-column>
                <el-table-column align="center" prop="imgUrl" label="封面图" min-width="60">
                    <template slot-scope="scope">
                        <cusImage class="cusImage_imgUrl" v-if="scope.row.imgUrl" style="width: 30px; height: 30px;"
                            :src="`${imgUrl}/${scope.row.imgUrl}`"
                            :preview-src-list="[`${imgUrl}/${scope.row.imgUrl}`]">
                        </cusImage>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="contentUrl" label="详情图" min-width="270">
                    <template slot-scope="scope">
                        <div v-if="scope.row.contentUrl" class="contentUrl">
                            <cusImage v-for="(val, key) in scope.row.contentUrl.split(',')" :key="key"
                                style="width: 30px; height: 30px;margin-right: 5px;" :src="`${imgUrl}/${val}`"
                                :preview-src-list="scope.row.contentUrl.split(',').map(val1 => `${imgUrl}/${val1}`)">
                            </cusImage>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="sort" label="排序" min-width="50">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import slideshowAction from "@/components/slideshowAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        slideshowAction,
    },
    data() {
        //这里存放数据
        return {
            imgUrl: "",
            tableHeight: 0,
            getRequestData: {
                className: '',
                classId: "",
                state: "",
            },
            returnData: {
                list: []
            },
            classifyList: [],
            buttonList: [],
            selectedDataList: [],
            dialogVisible: false,



        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        radioChange() {
            this.searchData()
        },
        selecDataAction(data) {
            this.selectedDataList = data
        },
        drawerCancel() {
            this.dialogVisible = false
            this.getDataList()
        },
        // 动作集合
        actionSet(actionData) {

            switch (actionData.actionType) {
                case 1:
                    this.dialogVisible = true;
                    this.actionData = {
                        cate: 0,
                        formData: "0",
                        oldData: "",
                        classifyList: this.classifyList,
                    };
                    break;
                case 2:
                    if (this.selectedDataList.length < 1) {
                        this.$message({
                            message: '请先选择您要修改的数据条目',
                            type: 'error'
                        });
                        return false
                    }

                    if (this.selectedDataList.length > 1) {
                        this.$message({
                            message: '编辑信息只能选择一条数据，请勿多选',
                            type: 'error'
                        });
                        return false
                    }

                    this.dialogVisible = true;
                    this.actionData = {
                        cate: 1,
                        formData: "0",
                        oldData: this.selectedDataList,
                        classifyList: this.classifyList,
                    };
                    this.openActionBox(actionData.actionType)
                    break;
                case 3:
                    this.delDataAction()
                    break;
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        // 数据搜索
        searchData() {
            this.getDataList()
        },
        // 删除
        delDataAction() {

            if (this.selectedDataList.length == 0) {
                this.$message({
                    message: '请勾选要删除的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.selectedDataList[0]
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: this.selectedDataList.map(item => item.id)
                }
                let responseData = await this.$http.carouseldelete(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            }).catch(() => { });

        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.carouselqueryList(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async getDataClassify() {
            let responseData = await this.$http.carouseClassifyqueryList({})
            if (responseData.status == 200) {
                this.classifyList = this.handleJurisdiction(responseData.result)
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    console.log(123456);

                    value['id'] = value['id']
                    value['value'] = value['id']
                    value['label'] = value['className']

                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgUrl = window.global_config.BASE_IMG_URL
        this.getDataList()
        this.getButtonList()
        this.getDataClassify()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.contentUrl {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 250px;
}

.cusImage_imgUrl ::v-deep .el-image__error {
    font-size: 7px !important;
}

.contentUrl ::v-deep .el-image__error {
    font-size: 7px !important;
}
</style>
